// NOTE: 큐레이터 쿠폰 API 에러 코드 (위키: /wiki/spaces/rSMDpOBmZ7v1/pages/225116201/API)
export const COUPON_ERROR_CODES = {
  ALREADY_PUBLISHED: 'COUPON_ALREADY_PUBLISHED',
  LIMIT_EXCEEDED: 'COUPON_LIMIT_EXCEEDED',
  INVALID: 'COUPON_INVALID',
  EXPIRED: 'COUPON_EXPIRED',
  NOT_STARTED: 'COUPON_NOT_STARTED',
  NOT_BELONG_TO_INFLUENCER: 'COUPON_NOT_BELONG_TO_INFLUENCER',
  NO_COUPONS_AVAILABLE: 'NO_COUPONS_AVAILABLE',
} as const;

export type CouponErrorCode = (typeof COUPON_ERROR_CODES)[keyof typeof COUPON_ERROR_CODES];
